// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LUxbyPGPgT84uJ {
  width: 16px;
}
.CCtfuUSrLAMcYl {
  position: relative;
}
.hmIOcwGQkBBrix {
  position: relative;
  top: -4px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconSpacer": `LUxbyPGPgT84uJ`,
	"tagItem": `CCtfuUSrLAMcYl`,
	"editButton": `hmIOcwGQkBBrix`
};
export default ___CSS_LOADER_EXPORT___;
